import React from 'react';
import { useSelector } from 'react-redux';

import { PriceText } from './PriceComponentStyles';
import InfoWrapper from '../InfoWrapper/InfoWrapper';

const PriceComponent = ({ item = {}, display, isMobile, toOpenModal = false, isTile }) => {
	const defaultTermsAndConditions = useSelector((state) => state.mice.hotelSearchData.defaultTermsAndConditions);
	const { priceSubHeader, formattedPrice, servicesIncluded, termsAndConditions = defaultTermsAndConditions } = item;
	if (!formattedPrice) {
		return null;
	}

	return (
		<>
			{priceSubHeader &&
				<PriceText text_align={!isMobile && 'right'} fsize='12px' color='#4a4a4a' display={display} right_M='5'>{priceSubHeader}
				</PriceText>}
			<PriceText text_align={!isMobile && 'right'} fsize='18px' color='#000' top_P='5' f_weight='900' display={display} right_M={!isMobile && '5'}>{formattedPrice}
				{termsAndConditions.length > 0 && <InfoWrapper isTile={isTile} toOpenModal={toOpenModal} isMobile={isMobile} termsAndConditions={termsAndConditions} />}
			</PriceText>
			{servicesIncluded &&
				<PriceText
					text_align={!isMobile && 'right'} fsize='11px' color='#11A187' top_P='5' left_M={isMobile && '4'}
					title={servicesIncluded} display={display}>{servicesIncluded}
				</PriceText>}
		</>
	);
};

export default PriceComponent;
